exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "*{\n  margin: 0;\n  padding: 0;\n}\n\n\n", "", {"version":3,"sources":["D:/OITWebSite-master/OITWebSite-master/static/D:/OITWebSite-master/OITWebSite-master/static/publick_css.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;CACZ","file":"publick_css.css","sourcesContent":["*{\n  margin: 0;\n  padding: 0;\n}\n\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./static/publick_css.css
// module id = GlfC
// module chunks = 14